import useMediaQuery from '@mui/material/useMediaQuery'

// ** Layout Imports
// !Do not remove this Layout import
import Layout from 'src/@core/layouts/Layout'

// ** Navigation Imports
import VerticalNavItems from 'src/navigation/vertical'
// HorizontalNavItems eliminado: themeConfig.layout='vertical' y disableCustomizer=true, la rama era inalcanzable

// ** Component Import
/*
  Se quitaron tres imports que nadie usaba pero que si entraban al chunk
  compartido:

    ServerSideVerticalNavItems / ServerSideHorizontalNavItems -> ambos importan
    axios para pedir /api/vertical-nav/data, una ruta de API que no existe bajo
    `output: 'export'`. Sus llamadas ya estaban comentadas aca abajo.

    HorizontalAppBarContent -> arrastraba Autocomplete, UserDropdown,
    NotificationDropdown y ShortcutsDropdown. Es inalcanzable por el mismo
    motivo por el que ya se habia quitado HorizontalNavItems:
    themeConfig.layout es 'vertical' y disableCustomizer esta en true.

  Un import sin usar no lo elimina el tree shaking cuando el modulo tiene
  efectos de importacion, y aca los tenia: se pagaba parseo y descarga en la
  primera carga de todas las paginas.
*/
import VerticalAppBarContent from './components/vertical/AppBarContent'

// ** Hook Import
import { useSettings } from 'src/@core/hooks/useSettings'

// ** Contenido SEO al pie de las herramientas
import ToolContent from 'src/@core/components/seo/ToolContent'

const UserLayout = ({ children, contentHeightFixed }) => {
  // ** Hooks
  const { settings, saveSettings } = useSettings()

  /**
   *  The below variable will hide the current layout menu at given screen size.
   *  The menu will be accessible from the Hamburger icon only (Vertical Overlay Menu).
   *  You can change the screen size from which you want to hide the current layout menu.
   *  Please refer useMediaQuery() hook: https://mui.com/material-ui/react-use-media-query/,
   *  to know more about what values can be passed to this hook.
   *  ! Do not change this value unless you know what you are doing. It can break the template.
   */
  const hidden = useMediaQuery(theme => theme.breakpoints.down('lg'))
  if (hidden && settings.layout === 'horizontal') {
    settings.layout = 'vertical'
  }

  return (
    <Layout
      hidden={hidden}
      settings={settings}
      saveSettings={saveSettings}
      contentHeightFixed={contentHeightFixed}
      verticalLayoutProps={{
        navMenu: {
          navItems: VerticalNavItems()
        },
        appBar: {
          content: props => (
            <VerticalAppBarContent
              hidden={hidden}
              settings={settings}
              saveSettings={saveSettings}
              toggleNavVisibility={props.toggleNavVisibility}
            />
          )
        }
      }}
    >
      {children}

      {/*
        Bloque de contenido al pie: como funciona, pasos, FAQ y enlaces internos.
        Se monta aca en vez de en cada pagina porque asi es una sola edicion en lugar
        de 20 JSX distintos. Devuelve null en las rutas sin entrada en el catalogo,
        asi que la home, las guias y las legales no lo muestran.
      */}
      <ToolContent />
    </Layout>
  )
}

export default UserLayout
